import ProductClosures from "./product-closures";
import ProductColorSwatches from "./product-color-swatches";
import ProductDetails from "./product-details";
import ProductImages from "./product-images";
import ProductSpecSwiper from "./product-spec-swiper";
import ProductBackOrderNotice from "./product-back-order-notice";

const ProductPage = () => {
    ProductDetails();    
    if( document.querySelector('[data-product-type*="Item"]') !== null ) {
        ProductBackOrderNotice();
        ProductImages();
        if( document.querySelector('[data-product-has-closures="true"]' ) !== null  ) {    
            ProductClosures();
        }
        ProductSpecSwiper();
        if( document.querySelector('[data-option-key="Color"]' ) !== null ) {
            ProductColorSwatches();
        }

        const productSpecModal = document.getElementById('size-info-modal');
    }
}

export default ProductPage;

